<template>
  <el-dialog
    :title="$t('mappingDomain.edit')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item :label="$t('mappingDomain.name')" prop="domainName">
        <el-input
          v-model="form.domainName"
          :placeholder="$t('mappingDomain.namePlaceholder')"
        />
      </el-form-item>
      <el-form-item :label="$t('mappingDomain.configItem')" prop="domain">
        <el-input
          v-model="form.domain"
          :placeholder="$t('mappingDomain.configItemPlaceholder')"
        />
      </el-form-item>
      <el-form-item :label="$t('mappingDomain.seq')" prop="seq">
        <el-input
          v-model="form.seq"
          type="number"
          :placeholder="$t('mappingDomain.seqPlaceholder')"
        />
      </el-form-item>
      <el-form-item :label="$t('mappingDomain.remark')" prop="remark">
        <el-input
          v-model="form.remark"
          type="textarea"
          :placeholder="$t('mappingDomain.remarkPlaceholder')"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateMappingDomain } from '@/api/dev/mappingDomainApi'

export default {
  name: 'EditMappingDomain',
  data() {
    return {
      dialogVisible: false,
      form: {
        id: '',
        domainName: '',
        domain: '',
        seq: '',
        remark: ''
      },
      rules: {
        domainName: [
          { required: true, message: this.$t('mappingDomain.nameRequired'), trigger: 'blur' }
        ],
        domain: [
          { required: true, message: this.$t('mappingDomain.configItemRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('mappingDomain.configItemMaxLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('mappingDomain.seqRequired'), trigger: 'blur' },
          { max: 12, message: this.$t('mappingDomain.seqMaxLength'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('mappingDomain.remarkRequired'), trigger: 'blur' },
          { max: 256, message: this.$t('mappingDomain.remarkMaxLength'), trigger: 'blur' }
        ],
        id: [
          { required: true, message: this.$t('mappingDomain.idRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      this.form = { ...data }
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        await updateMappingDomain(this.form)
        this.$message.success(this.$t('mappingDomain.editSuccess'))
        this.dialogVisible = false
        this.$emit('success')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>